import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'results-chart',
    templateUrl: 'results-chart.component.html',
})
export class ResultsChart {

    results;
    refMin;
    refMax;
    patient;
    env = environment;
    constructor(
        public dialogRef: MatDialogRef<ResultsChart>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.results = this.data.results;
        this.patient = this.data.patient;
        this.refMin = parseFloat(this.data.referenceValueMin)
        this.refMax = parseFloat(this.data.referenceValueMax)

        this.lineChartLabels = this.results.map(result => result.orderDate).reverse();
        this.lineChartData = [
            { 
                data: this.results.map(result => result.result).reverse(), 
                label: this.results[0].testId,
                pointBackgroundColor: function(context){
                    var index = context.dataIndex;
                    var value = context.dataset.data[index];
                    return value < refMin || value > refMax? 'red' :  // draw negative values in red
                            'green';
                } 
            },
        ];
        var a = this.lineChartLabels
        let refMin = this.refMin;
        let refMax = this.refMax;
        let suggestedMin = this.refMin - 1;
        let suggestedMax = this.refMax + 1;
        let oData = [...data.results].reverse();
        this.lineChartOptions = {
            responsive: true,
            title:{
                text: this.data.description + ` (${this.data.id})`,
                display: true
            },
            legend: {
                display: false,
            },
            scales: {
                // We use this empty structure as a placeholder for dynamic theming.
                xAxes: [{}],
                yAxes: [
                    {
                        scaleLabel: {
                            display: true,
                            labelString: this.data.unit,
                        },
                        ticks: {
                            suggestedMin: suggestedMin,
                            suggestedMax: suggestedMax,
                        },
                        id: 'y-axis-0',
                        position: 'left',
                    }
                ]
            },
            annotation: {
                drawTime: 'beforeDatasetsDraw',
                annotations: [
                    {
                        type: "box",
                        mode: "horizonal",

                        scaleID: "y-axis-box",
                        yScaleID: 'y-axis-0',
                        yMax: this.refMax,
                        yMin: this.refMin,
                        backgroundColor: 'rgba(0,255,0,0.05)',
                        borderWidth: 2,
                    }
                    ,
                    {
                        drawTime: 'afterDatasetsDraw',
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        value: this.refMax,
                        borderColor: 'rgba(0,128,0,0.5)',
                        borderWidth: 2,
                        borderDash: [10, 5],
                        label: {
                            enabled: true,
                            fontColor: 'white',
                            content: this.refMax.toString(),
                            position: "right",
                        }
                    },
                    {
                        drawTime: 'afterDatasetsDraw',
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        value: this.refMin,
                        borderColor: 'rgba(0,128,0,0.5)',
                        borderWidth: 2,
                        borderDash: [10, 5],
                        label: {
                            enabled: true,
                            fontColor: 'white',
                            content: this.refMin.toString(),
                            position: "right",
                        }
                    }
                ]
            },
            tooltips: {
                callbacks: {
                  title: function(tooltipItem, data ) {
                      
                    //var idx = datos.labelstooltipItem[0].index;  
                    return oData[tooltipItem[0].index].orderId +
                    '\n' + oData[tooltipItem[0].index].orderDate;
                  }/*,
                  label: function(tooltipItem, data) {
                    return ;
                  },
                  afterLabel: function(tooltipItem, data) {
                      //console.log(tooltipItem)
                    //return oData[tooltipItem.index].result;
                  }*/
                },
          
                //backgroundColor: "#949",
                //bodyFontColor: "#999",
               // borderColor: "#799",
                //borderWidth: 2,
                //caretPadding: 15,
                //colorBody: "#666",
                //displayColors: false,
                enabled: true,
                intersect: true,
                mode: "x",
                //titleFontColor: "#999",
                //titleMarginBottom: 15,
                xPadding: 5,
                yPadding: 5
              }
        }

    }


    public lineChartData: ChartDataSets[];
    public lineChartLabels: Label[];
    public lineChartOptions: ChartOptions & { annotation: any };
    public lineChartColors: Color[] = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.0)',
            borderColor: 'rgba(0,0,0,1)',
            //pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
          },
    ];
    public lineChartLegend = true;
    public lineChartType = 'line';
    public lineChartPlugins = [pluginAnnotations/*,
        {
            beforeDraw(chart, easing) {
              const ctx = chart.ctx;
              const chartArea = chart.chartArea;
              const top = chartArea.top; // Use a value of 0 here to include the legend
        
              ctx.save();
              ctx.fillStyle = 'rgba(255,255,255,)';
        
              ctx.fillRect(chartArea.left, top, chartArea.right - chartArea.left, chartArea.bottom - top);
              ctx.restore();
            }
        }*/
          ];


}

